module.exports = __webpack_public_path__ + "img/overdueCompany.188e1fa7.png";